import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const stackexchange = defineConnector({
  identifier: "stackexchange",
  name: "Stack Exchange",
  tagLine: "Developer Q&A community",
  logo,
  protocol: "http",
  tags: ["documents", "productivity"],
  defaultUrlPattern: () => "https://api\\.stackexchange\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create a Stack Exchange app",
      items: [
        {
          kind: "markdown",
          content:
            "Go to [Stack Apps](https://stackapps.com/apps/oauth/register) and register a new OAuth application to get your client ID and client secret.",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your app’s settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/stackexchange/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Configure scopes",
      items: [
        {
          kind: "input",
          label: "Scopes",
          placeholder: "no_expiry",
          helperText: "Space-separated list of permission scopes.",
          target: { kind: "oauthConnection", field: "scopes" },
        },
      ],
    },
    {
      title: "Authorize your Stack Exchange account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your Stack Exchange account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://stackoverflow.com/oauth",
    tokenEndpoint: () => "https://stackoverflow.com/oauth/access_token/json",
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.stackexchange.com/2.3/me?site=stackoverflow",
  },
});
